import * as React from "react";

function OneEcosystem() {
  return (
    <header id="features" className="mb-8 text-center max-sm:mb-10 m-12 p-12">
      <h1 className="mb-4 text-5xl font-bold leading-tight text-teal-600 max-md:text-4xl max-sm:text-3xl">
        One Ecosystem. Infinite Possibilities.
      </h1>
      <p className="text-xl leading-normal text-amber-500 max-sm:text-base">
        Everything you need to streamline operations and scale your business.
      </p>
    </header>
  );
}

export default OneEcosystem;
